export function mobileFiltering() {
    var $ = jQuery.noConflict();
    var $filters = document.querySelector('.filters-criteria');

    if ($filters !== null) {
        let selectedFilterCount = $filters.querySelectorAll('ol li').length;
        if (selectedFilterCount > 0) {
            let countOverlay = document.querySelector('.count-overlay');
            if (countOverlay !== null) {
                countOverlay.innerHTML = selectedFilterCount;
                countOverlay.classList.remove("d-none");
            }
        }
    }
}

export function selectedFilters() {
    var $ = jQuery.noConflict();
    var $toolbarContainer = document.querySelector(".filters-toggle-container");
    var $selectedFilters = $(".selected-filters");
    var $selectedFiltersContainer = $('.selected-filters-container');
    var $filters = document.querySelector('.filters-criteria');

    if ($selectedFilters.length <= 1 && $filters !== null) {
        $selectedFilters.html($filters);
        $selectedFiltersContainer.before($toolbarContainer);
        $filters.classList.remove("d-none"); 
    } 
}

export function selectedFilterLoading() {
    const triggerClass = document.querySelectorAll('.amshopby-attr, .amshopby-attr-selected, .amshopby-cat');
    const spinnerWrapper = document.querySelector('.block-layered-nav .spinner-wrapper');
    const spinner = document.querySelector('.block-layered-nav .spinner-wrapper .spinner-border');
    const layeredNav = document.querySelector('.block-layered-nav');

    triggerClass.forEach(el => {
        el.addEventListener('click', (e) => {
            const layeredNavDim = layeredNav.getBoundingClientRect();
            const y = e.clientY - layeredNavDim.top;
            spinnerWrapper.style.display = 'block';
            spinner.style.top = y + 'px';

            setTimeout(() => {
                // If page doesn't refresh correctly for some reason, remove the spinner
                spinnerWrapper.style.display = 'none';
            }, 10000);
        });
    });

    // Check for both Amasty and core Magento category filters
    // const categoryFilterAmasty = document.querySelector('#narrow-by-list dd:has(li.amshopby-cat.level0)');
    // const categoryFilterCore = document.querySelector('#narrow-by-list dd:has(ol li)');
    // const categoryFilter = categoryFilterAmasty || categoryFilterCore;
    // const filterTitle = categoryFilter?.previousElementSibling;

    // if (categoryFilter) {
    //     // Check for Amasty category items
    //     const amastyItems = categoryFilter.querySelectorAll('li.amshopby-cat.level0');
    //     const visibleAmastyItems = Array.from(amastyItems).filter(item => item.offsetParent !== null);
        
    //     // Check for core Magento category items (simple <li> elements in <ol>)
    //     const coreItems = categoryFilter.querySelectorAll('ol > li');
    //     const visibleCoreItems = Array.from(coreItems).filter(item => item.offsetParent !== null);
        
    //     const hasMultipleVisible = visibleAmastyItems.length > 1 || visibleCoreItems.length > 1;

    //     // Search for a nested list (level1+) within any of the Amasty items
    //     const hasSubcategoryTree = Array.from(visibleAmastyItems).some(item =>
    //         item.querySelector('ol li.amshopby-cat.level1') !== null
    //     );

    //     // Check if core items have subcategories (nested <ol> elements)
    //     const hasCoreSubcategories = Array.from(visibleCoreItems).some(item =>
    //         item.querySelector('ol') !== null
    //     );

    //     // Hide if there's only one visible item and no subcategories (for both Amasty and core)
    //     if (!hasMultipleVisible && !hasSubcategoryTree && !hasCoreSubcategories) {
    //         if (filterTitle) filterTitle.style.display = 'none';
    //         categoryFilter.style.display = 'none';
    //     }
    // }

    // If url has brands in it, don't hide level 0 
    // const url = window.location.href;
    // if (url.includes('brands')) {
    //     const level0Items = categoryFilter.querySelectorAll('.block-layered-nav dd li.amshopby-cat.level0');
    //     level0Items.forEach(item => {
    //         item.style.display = 'block';
    //     });
    // }
}

jQuery(document).on("click", "#filters-toggle a", function (e) {
    e.preventDefault();

    const $btn = jQuery(this);
    const targetSelector = $btn.data("toggle") || "#layered-nav-left";
    const $target = jQuery(targetSelector);

    const isActive = $btn.hasClass("active");

    // Toggle active classes
    $btn.toggleClass("active");
    $target.toggleClass("active");

    // Add/remove body class
    if (!isActive) {
        jQuery("body").addClass("filters-open");
        jQuery("html").addClass("filters-open");
    } else {
        jQuery("body").removeClass("filters-open");
        jQuery("html").removeClass("filters-open");
    }
});

jQuery(document).on("click", "#filters-clear", function (e) {
    e.preventDefault();

    // Remove active states
    jQuery("#filters-toggle a").removeClass("active");
    jQuery("#layered-nav-left, #filters").removeClass("active");

    // Remove body class
    jQuery("body").removeClass("filters-open");
    jQuery("html").removeClass("filters-open");
});